export default "__VITE_ASSET__B_48aemb__"